import { Component } from '@angular/core';

@Component({
  selector: 'app-annuity-rate-watch-lifetime-income-tool',
  templateUrl: './annuity-rate-watch-lifetime-income-tool.component.html',
  standalone: false
})
export class AnnuityRateWatchLifetimeIncomeToolComponent {
  //need to add prod url once whitelisted
  iframeUrl = 'https://qa.portal.figmarketingusercontent.com/annuity-rate-watch-quoting-tool.template.html';
}
